import { Box, useColorModeValue } from "@chakra-ui/react";
import { memo, useContext } from "react";
import { RTableContext } from "./RTableContext";
import { RTrContext } from "./RTrContext";

const RTd = memo(
  /**
   * @typedef {Object} Props
   * @property {number} [_columnIndex]
   * @property {import("react").ReactNode} [children]
   *
   * @param {Props} props
   */
  function RTd({ _columnIndex: columnIndex = -1, children }) {
    const { columns, responsiveBreakpoint, isStriped } =
      useContext(RTableContext);

    const { isFirstRow, isLastRow } = useContext(RTrContext);

    const color = useColorModeValue("gray.700", "gray.300");

    return (
      <Box
        verticalAlign="middle"
        display="table-cell"
        px=".5rem"
        pt=".5rem"
        pb={isStriped ? ".5rem" : undefined}
        // borderBottomWidth="1px"
        sx={{
          "&:first-of-type": {
            pl: isStriped ? "1rem" : undefined,
          },
          "&:last-of-type": {
            pr: isStriped ? "1rem" : undefined,
          },
          [`@container (max-width: ${responsiveBreakpoint})`]: {
            "&:first-of-type": {
              pt: isStriped ? "1rem" : isFirstRow ? 0 : "1rem",
            },
            "&:last-of-type": {
              pb: isStriped ? "1rem" : isLastRow ? 0 : "1rem",
            },
            "&": {
              display: "block",
              px: isStriped ? "1rem" : 0,
              // borderBottomWidth: 0,
            },
          },
        }}
        _first={{
          pl: 0,
        }}
        _last={{
          pr: 0,
        }}>
        {columns?.[columnIndex]?.title && (
          <Box
            display="none"
            color={color}
            fontWeight="bold"
            sx={{
              [`@container (max-width: ${responsiveBreakpoint})`]: {
                "&": {
                  display: "block",
                },
              },
            }}>
            {columns[columnIndex].title}
          </Box>
        )}

        <Box
          textAlign={columns[columnIndex]?.textAlign}
          sx={{
            [`@container (max-width: ${responsiveBreakpoint})`]: {
              "&": {
                textAlign: "left",
              },
            },
          }}>
          {children}
        </Box>
      </Box>
    );
  },
);

export default RTd;
